import React from 'react';
import ArrowRight from "../../../assets/arrow-right.svg?react";
import { RenderType } from "../types";

interface PagePreviewProps {
    page: any;
    renderType: number;
    showBackground: boolean;
    columnsCount: number;
}

const PagePreview: React.FC<PagePreviewProps> = ({ page, renderType, showBackground, columnsCount }) => {
    const isRowLayout = renderType === RenderType.Row && !!page.mainImage?.value?.url;

    const articleContainerClasses = `h-full group flex ${isRowLayout ? 'flex-row' : 'flex-col'}`;
    const articleContentClasses = `${!showBackground ? 'px-[23px] py-[28px]' : ''} ${isRowLayout ? 'w-1/2' : 'flex-grow'}`;
    const headingClasses = `text-primary mb-4 font-normal ${columnsCount <= 2 ? 'text-[28px] font-medium' : 'text-2xl'}`;
    const imageClasses = `object-cover ${isRowLayout ? 'w-1/2 pl-6' : 'w-full h-56'}`;

    return (
        <a href={page.url} className={articleContainerClasses} style={{ backgroundColor: !showBackground ? '#EBF8EE' : 'transparent' }}>
            <div className={articleContentClasses}>
                <h3 className={headingClasses}>{page.name}</h3>
                <p className="line-clamp-4 text-primary text-base font-normal mb-4">{page.mainIntro?.value}</p>
                <div className="text-primary group-hover:translate-x-2 transition-all ease-out group-hover:text-primaryBlue mb-4">
                    <ArrowRight />
                </div>
            </div>
            {page.mainImage?.value?.url && <img loading="lazy" decoding="async" src={page.mainImage.value.url} alt="" className={imageClasses} />}
        </a>
    );
};

export default PagePreview;
